import { Link } from "react-router-dom";
import { openPopup } from "../../../store/popupSlice"
import { useDispatch } from "react-redux";

export default function BlinkitBuild({ data }) {
    const dispatch = useDispatch();
  if (!data || !data.boxes || data.boxes.length === 0) {
    return null;
  }
  return (
    <>
      <section className="blink-build-area">
        <img src="/assets/home/lyft-intro-vec2.webp" alt="vector" className="img-responsive blink-build-vec" />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="blink-build-content">
                <h2 className="heading center-heading"><span className="gradiant-color">{data.titlePart1}</span> {data.titlePart2}</h2>
                <p className="sub-heading">{data.description}</p>
              </div>
            </div>

            <div className="col-lg-10 col-md-12">
              <div className="row">
                {data.boxes.map((box, index) => (
                  <div className="col-lg-6 col-md-6" key={index}>
                    <div className="blink-build-box">
                      <img src={box.image} alt="build" />
                      <p>{box.desc}</p>
                      <Link onClick={() => dispatch(openPopup())} className="gradiant-color">{box.cta}</Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
